
(function(){
  'use strict';
  var root = document.documentElement;
  var RM = false;
  var qs = function(s,scope){ return (scope||document).querySelector(s); };
  var qsa = function(s,scope){ return Array.prototype.slice.call((scope||document).querySelectorAll(s)); };
  var safe = function(name,fn){ try{ fn(); }catch(err){ console.error('[Prayasa motion] '+name,err); } };

  safe('motion indices',function(){
    qsa('.nav__in .ni,.dw__p nav > *,.hero__chips .chip,.wcard,.pcard,.exp,.gift-card,.story-stats > div,.lstep,.mtile,.maker-card,.partner-logo,.tcard,.igt,.fut__t > *').forEach(function(el,i){
      var group = el.parentElement;
      var siblings = group ? Array.prototype.slice.call(group.children) : [];
      var localIndex = siblings.indexOf(el);
      el.style.setProperty('--motion-i', Math.max(0, localIndex >= 0 ? localIndex : i));
    });
  });

  safe('section map',function(){
    var map = [
      ['.hero','hero-motion'],['.rib','ribbon-motion'],['#worlds-sec','worlds-motion'],['#best-sec','bestseller-motion'],
      ['.explore-sec','explore-motion'],['.find','finder-motion'],['.conc-v2','concierge-motion'],['.story-v2','story-motion'],
      ['.ledg','ledger-motion'],['.moments-sec','moments-motion'],['.makers-v2','makers-motion'],['.partner-collabs','partner-motion'],
      ['.voices-sec','voices-motion'],['.instagram-sec','instagram-motion'],['.corp','corporate-motion'],['.news','newsletter-motion'],['.fut','footer-motion']
    ];
    map.forEach(function(pair){ var el=qs(pair[0]); if(el){ el.classList.add('motion-section',pair[1]); } });
  });

  safe('section observer',function(){
    var sections = qsa('.motion-section');
    if(RM || !('IntersectionObserver' in window)){
      sections.forEach(function(el){ el.classList.add('is-visible'); });
      qsa('.r,.rs,.ph').forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var sectionIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); sectionIO.unobserve(entry.target); }
      });
    },{threshold:.08,rootMargin:'0px 0px -5% 0px'});
    sections.forEach(function(el){ sectionIO.observe(el); });

    var revealIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('in'); revealIO.unobserve(entry.target); }
      });
    },{threshold:.08,rootMargin:'0px 0px -3% 0px'});
    qsa('.r,.rs,.ph').forEach(function(el){ revealIO.observe(el); });
  });

  safe('header and progress',function(){
    var hd=qs('#hd'),pb=qs('#pbar'),tt=qs('#totop'),last=0,ticking=false;
    function update(){
      var y=window.scrollY||document.documentElement.scrollTop||0;
      if(hd){
        hd.classList.toggle('scrolled',y>20);
        hd.classList.remove('up');
      }
      if(pb){ var h=document.documentElement.scrollHeight-window.innerHeight; pb.style.width=(h>0?(y/h*100):0)+'%'; }
      if(tt) tt.classList.toggle('on',y>700);
      last=y;ticking=false;
    }
    window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(update); ticking=true; } },{passive:true});
    update();
    if(tt) tt.addEventListener('click',function(){ window.scrollTo({top:0,behavior:RM?'auto':'smooth'}); });
  });

  safe('drawer',function(){
    var dw=qs('#dw'),bg=qs('#burg');
    function close(){ if(!dw)return; dw.classList.remove('open'); document.body.style.overflow=''; }
    if(bg&&dw) bg.addEventListener('click',function(){ dw.classList.add('open'); document.body.style.overflow='hidden'; });
    if(dw) qsa('[data-x]',dw).forEach(function(x){ x.addEventListener('click',close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });

    /* Mobile menu accordion: only one category open at a time. Opening a new
       one closes whichever was already open, instead of stacking. */
    var accHeads = qsa('.acc__h');
    accHeads.forEach(function(h){
      h.addEventListener('click',function(){
        var a=h.parentElement,b=h.nextElementSibling;
        if(!a||!b) return;
        var willOpen = !a.classList.contains('open');
        accHeads.forEach(function(otherH){
          if(otherH===h) return;
          var oa=otherH.parentElement, ob=otherH.nextElementSibling;
          if(oa && oa.classList.contains('open')){
            oa.classList.remove('open');
            if(ob) ob.style.maxHeight='0';
          }
        });
        a.classList.toggle('open', willOpen);
        b.style.maxHeight = willOpen ? b.scrollHeight+'px' : '0';
      });
    });
  });

  safe('drag rails',function(){
    qsa('.crail,.ltrack,.ttrack,.exps').forEach(function(rail){
      var down=false,dragging=false,suppressClick=false,startX=0,startLeft=0,pointerId=null;
      var threshold=7;

      rail.addEventListener('pointerdown',function(e){
        if(e.button !== undefined && e.button !== 0) return;
        down=true;
        dragging=false;
        suppressClick=false;
        pointerId=e.pointerId;
        startX=e.clientX;
        startLeft=rail.scrollLeft;
      });

      rail.addEventListener('pointermove',function(e){
        if(!down) return;
        var delta=e.clientX-startX;
        if(!dragging && Math.abs(delta)<threshold) return;

        if(!dragging){
          dragging=true;
          suppressClick=true;
          if(rail.setPointerCapture && pointerId !== null){
            try{rail.setPointerCapture(pointerId);}catch(err){}
          }
        }

        rail.scrollLeft=startLeft-delta*1.22;
        e.preventDefault();
      });

      function endDrag(){
        down=false;
        dragging=false;
        pointerId=null;
      }

      ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
        rail.addEventListener(ev,endDrag);
      });

      rail.addEventListener('click',function(e){
        if(!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        suppressClick=false;
      },true);
    });
  });

  safe('carousel buttons',function(){
    qsa('[data-prev],[data-next]').forEach(function(btn){
      var id=btn.getAttribute('data-prev')||btn.getAttribute('data-next'),rail=qs('#'+id),dir=btn.hasAttribute('data-next')?1:-1;
      btn.addEventListener('click',function(){ if(!rail)return;var c=rail.children[0],w=c?c.getBoundingClientRect().width+18:Math.min(320,window.innerWidth*.78);rail.scrollBy({left:dir*w,behavior:RM?'auto':'smooth'}); });
    });
  });

  safe('auto rails',function(){
    if(RM) return;
    qsa('[data-auto]').forEach(function(t){
      if(t.dataset.motionClone==='true') return;
      var sp=parseFloat(t.getAttribute('data-auto'))||.35;
      t.insertAdjacentHTML('beforeend',t.innerHTML);
      t.dataset.motionClone='true';
      var paused=false,lastTime=performance.now(),pos=t.scrollLeft||0;
      ['mouseenter','focusin','pointerdown','touchstart'].forEach(function(ev){t.addEventListener(ev,function(){paused=true;},{passive:true});});
      ['mouseleave','focusout','pointerup','touchend'].forEach(function(ev){t.addEventListener(ev,function(){setTimeout(function(){pos=t.scrollLeft||0;paused=false;},ev.indexOf('touch')===0?1400:100);},{passive:true});});
      function tick(now){
        var dt=Math.min(34,now-lastTime);lastTime=now;
        if(paused){ pos=t.scrollLeft||0; }
        else if(t.scrollWidth>t.clientWidth){
          pos += sp*(dt/16.67);
          var half=t.scrollWidth/2;
          if(pos>=half) pos-=half;
          t.scrollLeft=pos;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  });

  safe('hero slider',function(){
    var sls=qsa('#heroSl .sl'),dots=qsa('#hdots button'),cur=0,timer=null;
    if(!sls.length||dots.length!==sls.length) return;
    function go(i){sls[cur].classList.remove('on');dots[cur].classList.remove('on');cur=(i+sls.length)%sls.length;sls[cur].classList.add('on');dots[cur].classList.add('on');}
    function start(){if(!RM)timer=setInterval(function(){go(cur+1);},4800);}
    dots.forEach(function(d,i){d.addEventListener('click',function(){if(timer)clearInterval(timer);go(i);start();});});
    start();
  });

  safe('story video',function(){
    var video=qs('.story-media video');
    if(!video) return;
    video.muted=true;video.playsInline=true;
    var play=function(){var p=video.play();if(p&&p.catch)p.catch(function(){});};
    if('IntersectionObserver' in window){
      var vio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)play();else video.pause();});},{threshold:.18});
      vio.observe(video);
    }else play();
  });

  safe('partner marquee health',function(){
    var track=qs('.partner-track');
    if(!track||RM)return;
    track.style.animationPlayState='running';
  });

  clearTimeout(window.__prayasaMotionFailSafe);
  root.classList.remove('motion-failsafe');
  root.classList.add('motion-live');
})();


/* Shopify theme editor safety */
document.addEventListener('shopify:section:load', function(){
  document.querySelectorAll('.r,.rs,.ph,.motion-section').forEach(function(el){
    el.classList.add('in','is-visible');
  });
});
